import React from "react";

import {
  ContentBlockData,
  FeatureToggle,
  PhSiteSettings
} from "../../models/app-data-model";
import AccordionGroup from "../accordion-group/accordion-group/AccordionGroup";
import AppConnector from "../app-connector/AppConnector";
import ArticleGroup from "../article-group/ArticleGroup";
import CompareGroup from "../compare-group/CompareGroup";
import ContentHeroBlock from "../content-hero-block/ContentHeroBlock";
import SingleContentBlockData from "../single-content-block-data/SingleContentBlockData";
import TwoColumnContentBlock from "../two-column-content-block/TwoColumnContentBlock";
import UserPathGroup from "../user-path-group/UserPathGroup";

export type ContentBlockProps = {
  contentBlock: ContentBlockData;
  featureToggles: FeatureToggle[];
  phSiteSettings: PhSiteSettings;
};

const ContentBlock: React.FC<ContentBlockProps> = ({ contentBlock, featureToggles, phSiteSettings }) => {
  const rendering = (
    <>
      {contentBlock?.article_group && <ArticleGroup articleGroupData={contentBlock.article_group} />}
      {contentBlock?.user_path_group && <UserPathGroup user_path_group={contentBlock.user_path_group} />}
      {contentBlock?.accordion_group && <AccordionGroup accordionGroup={contentBlock.accordion_group} />}
      {contentBlock?.single_content_block && <SingleContentBlockData singleContentBlock={contentBlock.single_content_block} featureToggles={featureToggles} />}
      {contentBlock?.two_column_block && <TwoColumnContentBlock content={contentBlock.two_column_block} featureToggles={featureToggles} />}
      {contentBlock?.compare_group && <CompareGroup content={contentBlock?.compare_group?.content} />}
      {contentBlock?.app_connector && <AppConnector appConnectorData={contentBlock.app_connector} phSiteSettings={phSiteSettings} />}
      {contentBlock?.content_hero && <ContentHeroBlock contentHeroBlock={contentBlock.content_hero} />}
    </>
  );

  return <>{rendering}</>;
};

export default ContentBlock;
